import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from '@gem/modules/i18n';

import { useCallLimitsParticipantsToastPresenter } from './CallLimitsParticipantsToast.presenter';
import styles from './CallLimitsParticipantsToast.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

export const CallLimitsParticipantsToast: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = useCallLimitsParticipantsToastPresenter();

  return (
    <>
      <CSSTransition
        in={!!presenter.reminderText}
        classNames={itemTransition}
        timeout={ANIMATION_TIMEOUT}
        mountOnEnter
        unmountOnExit
      >
        <button
          className={styles.event}
          onClick={presenter.onReminderParticipantsClick}
        >
          <div className={styles.eventText}>
            {presenter.reminderText && presenter.reminderText.join(' · ')}
          </div>
        </button>
      </CSSTransition>
      <CSSTransition
        in={presenter.isCallTimeLimitsVisible}
        classNames={itemTransition}
        timeout={ANIMATION_TIMEOUT}
        mountOnEnter
        unmountOnExit
      >
        <button
          className={styles.event}
          onClick={presenter.onReminderTimeClick}
        >
          <div className={styles.eventText}>
            {t('premium_feature_unlimited_calls_notification')}
          </div>
        </button>
      </CSSTransition>
    </>
  );
});
